export default __webpack_public_path__ + "static/media/deskcoachappicon.7f5cd513.svg";